import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Button, Table } from 'react-bootstrap';
import SEO from "components/seo";
import ApiService from 'services';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import { getOvers, getDrr } from 'utils/points';
import LoadingBar from 'components/LoadingBar';
import { getTeamLink } from 'utils/links';
import LiveMatches from 'components/livematches';
import MatchList from 'components/matchlist';

export default function TempHome() {

    const [data, setData] = useState({});
    const [loading, setLoading] = useState(true);
    const [briefSchedule, setBriefSchedule] = useState({});
    const [pointsTable, setPointsTable] = useState({})
    const [tourName, setTourName] = useState("");
    const [key, setKey] = useState('0');

    useEffect(() => {

        const fetchData = async () => {
            try {
                const response = await ApiService.getPendingScoreCards();
                //console.log(response);
                setData(response);
                setLoading(false);
            } catch (error) {
                // Handle error
                //
                console.log(error);
                setLoading(false);
            }
        };
        fetchData();

    }, [])
    useEffect(() => {

        const fetchData = async () => {
            try {
                const response = await ApiService.getBriefSchedule(79);
                //console.log(response);
                setBriefSchedule(response);
                setLoading(false);
            } catch (error) {
                // Handle error
                //
                console.log(error);
                setLoading(false);
            }
        };
        fetchData();

    }, [])
    useEffect(() => {

        const fetchData = async () => {
            try {
                const response = await ApiService.getPointsTable();
                //console.log(response);

                if (response && response.Tour.length > 0) {
                    setTourName(response.Tour[0].TourName)
                }

                for (let i = 0; i < response.PointTable.length; i++) {
                    response.PointTable[i].sort(function (a, b) {
                        var aFrr = (a.Played == "1") ? parseFloat(a.Drr) : parseInt(a.Score) / parseFloat(getOvers(a.Over)) || 0,
                            aOrr = (a.Played == "1") ? parseFloat(a.Opp_Drr) : parseInt(a.Opp_Score) / parseFloat(getOvers(a.Opp_Over)) || 0,
                            bFrr = (b.Played == "1") ? parseFloat(b.Drr) : parseInt(b.Score) / parseFloat(getOvers(b.Over)) || 0,
                            bOrr = (b.Played == "1") ? parseFloat(b.Opp_Drr) : parseInt(b.Opp_Score) / parseFloat(getOvers(b.Opp_Over)) || 0;

                        return b.TotalPoints - a.TotalPoints || b.Win - a.Win || b.Tie - a.Tie || a.Loss - b.Loss || parseFloat(bFrr - bOrr) - parseFloat(aFrr - aOrr);
                    });
                }
                setPointsTable(response);

                setLoading(false);
            } catch (error) {
                // Handle error
                //
                console.log(error);
                setLoading(false);
            }
        };
        fetchData();

    }, [])
    const getBriefScheduleView = () => {

        // Get the current date
        const currentDate = new Date();

        // Split matches into upcoming and past matches
        const upcomingMatches = briefSchedule.Matches
            ?.flat()
            .filter((oneMatch) => new Date(oneMatch.MatchDate2) > currentDate);
        return <MatchList slim={true} matches={upcomingMatches} label={"Upcoming Matches"} />
    };
    const getPendingScoreCardView = () => {
        if (data && data.Match && data.Bpub) {
            return <>
                <Table striped bordered hover responsive>
                    <thead>
                        <tr>
                            <th>Match</th>
                            <th>Date</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.Match.map((oneGroup, index) => {
                            return (
                                oneGroup.map((oneMatch, index) => {
                                    return <tr key={index}><td><span className="fw-bold">{oneMatch.Name}  vs {oneMatch.BatTeam2Name}  <span className="text-end"><a href={'tournament?v=Scores&t=' + oneMatch.TourId_n + '&Mid=' + oneMatch.MatchId}>Brief Score</a> </span></span><p className='p-0 m-0 small'> {oneMatch.PlaygroundName}</p></td><td>{oneMatch.MatchDate}</td></tr>
                                })
                            )
                        })}
                    </tbody>
                </Table>
            </>
        } else {
            return <h5>No Pending Scorecards</h5>
        }
    };

    const getPointsTableView = () => {

        if (pointsTable && pointsTable.Group && pointsTable.Group.length > 0) {
            return (
                <Tabs
                    id="controlled-tab-example"
                    activeKey={key}
                    onSelect={(k) => setKey(k)}
                    className=""
                    fill
                >
                    {pointsTable.Group.map((oneGroup, index) => {
                        return <Tab key={index} eventKey={index} title={oneGroup.Section[1] + ' ' + oneGroup.Group} className='custom-active-tab'>
                            <Table responsive className='border border-top-0'>

                                <thead>
                                    <tr>
                                        <th>Team</th>
                                        <th>P</th>
                                        <th>W</th>
                                        <th>T</th>
                                        <th>L</th>
                                        <th>A</th>
                                        <th>B</th>
                                        <th>NRR</th>
                                        <th>Pts</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {pointsTable.PointTable[index].map((oneRecord, index) => {
                                        let forOvers = getOvers(oneRecord.Over);
                                        let oppOvers = getOvers(oneRecord.Opp_Over);
                                        let forDrr = getDrr(oneRecord.Score, forOvers);
                                        let oppDrr = getDrr(oneRecord.Opp_Score, oppOvers);
                                        let netDrr = forDrr - oppDrr;

                                        return <tr key={index}>
                                            <td>
                                                {getTeamLink(oneRecord.TeamName, oneRecord.TeamId)}
                                            </td>
                                            <td>{oneRecord.Played}</td>
                                            <td>{oneRecord.Win}</td>
                                            <td >{oneRecord.Tie}</td>
                                            <td >{oneRecord.Loss}</td>
                                            <td>{oneRecord.Ab}</td>
                                            <td>{oneRecord.Bonus}</td>
                                            <td >{parseFloat(netDrr).toFixed(3)}</td>
                                            <td >{oneRecord.TotalPoints}</td>
                                        </tr>
                                    })}
                                </tbody>
                            </Table>

                        </Tab>
                    })}

                </Tabs>
            );
        } else {
            return <>No Points Table</>
        }
    };



    return (
        <main>
            <SEO template="index" />
            <Container className="px-0 flex-grow-1 overflow-auto">
                <Row>
                    <Col xs={12}>
                        <h1 className='text-center'>{tourName && tourName.length > 0 ? tourName + "Tournament" : "Welcome to TCA"}</h1>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12}>
                        <LiveMatches />
                    </Col>
                </Row>
                {!loading &&
                    <Row>
                        <Col xs={12} lg={6}>
                            <Row>
                                <Col xs={12} >
                                    <h2>Points Table</h2>
                                    {getPointsTableView()}
                                </Col>

                                <Col xs={12}  >
                                    <h2>Pending Score Cards</h2>
                                    {getPendingScoreCardView()}
                                </Col>
                            </Row>
                        </Col>
                        <Col xs={12} lg={6}>
                            <h2>Upcoming Schedule</h2>
                            {getBriefScheduleView()}
                        </Col>
                    </Row>
                }
                {loading && <LoadingBar show={loading} />}


            </Container>
        </main>
    );
}